import type { ServicePlan } from '@bharat-consultancy/shared';

/**
 * Renders plan variants (Basic/Standard/Premium) WITHOUT price points or
 * a booking CTA, per client request — the client wants every visitor
 * funneled through the ₹499 consultation call instead of self-service
 * checkout, so they can quote pricing directly based on the
 * consultation. `onSelectPlan` is no longer called from here; it's kept
 * as an optional prop (unused) rather than removed from the type, so
 * re-enabling pricing/booking later (see lib/bookingFlags.ts) is just
 * restoring the price block + Button below, not a rewrite.
 */
export function PricingTable({ plans }: { plans: ServicePlan[]; onSelectPlan?: (plan: ServicePlan) => void }) {
  if (plans.length === 0) return null;

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {plans.map((plan, i) => {
        const isPopular = i === 1 && plans.length > 1;
        return (
          <div
            key={plan.id}
            className={`relative flex flex-col rounded-lg border p-6 ${
              isPopular ? 'border-seal-blue shadow-stamp-lifted' : 'border-line shadow-stamp'
            }`}
          >
            {isPopular && (
              <span className="absolute -top-3 left-6 rounded-full bg-gold px-3 py-1 text-xs font-medium text-white">
                Most Popular
              </span>
            )}
            <h3 className="font-display text-lg font-semibold text-ink">{plan.planName}</h3>
            {plan.description && <p className="mt-2 text-sm leading-relaxed text-ink/60">{plan.description}</p>}
          </div>
        );
      })}
    </div>
  );
}
